var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1235_12504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.68 20.9993C25.04 20.9993 23.4533 20.7327 21.9733 20.2527C21.5067 20.0927 20.9867 20.2127 20.6267 20.5727L18.5333 23.1993C14.76 21.3993 11.2267 17.9993 9.34667 14.0927L11.9467 11.8793C12.3067 11.506 12.4133 10.986 12.2667 10.5193C11.7733 9.03934 11.52 7.45268 11.52 5.81268C11.52 5.09268 10.92 4.49268 10.2 4.49268H5.58667C4.86667 4.49268 4 4.81268 4 5.81268C4 18.1993 14.3067 28.4927 26.68 28.4927C27.6267 28.4927 28 27.6527 28 26.9193V22.3193C28 21.5993 27.4 20.9993 26.68 20.9993Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1235_12504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.492676)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.a601951f1e2e8287dbd9aed4d14fd9be.svg";
export { ForwardRef as ReactComponent };